'use strict';
import * as $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate$0024$002dChat$002dRead from "./app.api.-Pharmacy-App-Update$-Chat-Read.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$ChatRead$() {
}
export { $c_Lapp_api_PharmacyAppUpdate$ChatRead$ as $c_Lapp_api_PharmacyAppUpdate$ChatRead$ };
$c_Lapp_api_PharmacyAppUpdate$ChatRead$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate$ChatRead$.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$ChatRead$;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$ChatRead$() {
}
export { $h_Lapp_api_PharmacyAppUpdate$ChatRead$ as $h_Lapp_api_PharmacyAppUpdate$ChatRead$ };
$h_Lapp_api_PharmacyAppUpdate$ChatRead$.prototype = $c_Lapp_api_PharmacyAppUpdate$ChatRead$.prototype;
$c_Lapp_api_PharmacyAppUpdate$ChatRead$.prototype.toString__T = (function() {
  return "ChatRead";
});
$c_Lapp_api_PharmacyAppUpdate$ChatRead$.prototype.fromProduct__s_Product__Lapp_api_PharmacyAppUpdate$ChatRead = (function(x$0) {
  var id$5 = x$0.productElement__I__O(0);
  return new $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate$0024$002dChat$002dRead.$c_Lapp_api_PharmacyAppUpdate$ChatRead(id$5);
});
$c_Lapp_api_PharmacyAppUpdate$ChatRead$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_api_PharmacyAppUpdate$ChatRead(p);
});
var $d_Lapp_api_PharmacyAppUpdate$ChatRead$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$ChatRead$, "app.api.PharmacyAppUpdate$ChatRead$", ({
  Lapp_api_PharmacyAppUpdate$ChatRead$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$ChatRead$ as $d_Lapp_api_PharmacyAppUpdate$ChatRead$ };
var $n_Lapp_api_PharmacyAppUpdate$ChatRead$;
function $m_Lapp_api_PharmacyAppUpdate$ChatRead$() {
  if ((!$n_Lapp_api_PharmacyAppUpdate$ChatRead$)) {
    $n_Lapp_api_PharmacyAppUpdate$ChatRead$ = new $c_Lapp_api_PharmacyAppUpdate$ChatRead$();
  }
  return $n_Lapp_api_PharmacyAppUpdate$ChatRead$;
}
export { $m_Lapp_api_PharmacyAppUpdate$ChatRead$ as $m_Lapp_api_PharmacyAppUpdate$ChatRead$ };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$-Chat-Read$.js.map
